/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUsersEnabledDto
 */
export interface UpdateUsersEnabledDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUsersEnabledDto
     */
    userIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUsersEnabledDto
     */
    isEnabled?: boolean;
}

/**
 * Check if a given object implements the UpdateUsersEnabledDto interface.
 */
export function instanceOfUpdateUsersEnabledDto(value: object): value is UpdateUsersEnabledDto {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    return true;
}

export function UpdateUsersEnabledDtoFromJSON(json: any): UpdateUsersEnabledDto {
    return UpdateUsersEnabledDtoFromJSONTyped(json, false);
}

export function UpdateUsersEnabledDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUsersEnabledDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
    };
}

export function UpdateUsersEnabledDtoToJSON(json: any): UpdateUsersEnabledDto {
    return UpdateUsersEnabledDtoToJSONTyped(json, false);
}

export function UpdateUsersEnabledDtoToJSONTyped(value?: UpdateUsersEnabledDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
        'isEnabled': value['isEnabled'],
    };
}

